export default __webpack_public_path__ + "6f182a403c97e0e7964833b8cf529ee5.woff2";